module.exports = __webpack_public_path__ + "nc_static/media/devices.ef8dc5ed.svg";